const NAME = 'customerConfigurations';

const THEME = {
  DEFAULT: 0,
  DARK: 1
};

const THEME_NAME = {
  [THEME.DEFAULT]: 'Default theme',
  [THEME.DARK]: 'Dark theme'
};

export default {
  NAME,
  THEME,
  THEME_NAME
};
